import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M3 12C2.4375 12 2 11.5625 2 11V3C2 2.5 2.4375 2 3 2C3.5 2 4 2.5 4 3V8.8125C6.4375 4.75 10.875 2 16 2C23.6875 2 30 8.3125 30 16C30 23.75 23.6875 30 16 30C11 30 6.625 27.4375 4.125 23.5C3.6875 22.8125 4.1875 22 5 22C5.375 22 5.6875 22.25 5.875 22.5625C8 25.8125 11.75 28 16 28C22.625 28 28 22.625 28 16C28 9.375 22.625 4 16 4C11.5 4 7.625 6.4375 5.5625 10H11C11.5 10 12 10.5 12 11C12 11.5625 11.5 12 11 12H3Z'],
  name: 'uiUndo'
} as IconDefinition
